// Considered: none — the redesigned Stream facet bar (lens chips + Save as View) has no prior
// equivalent; the old feed filter popover (`FeedFilterState`) is being retired alongside
// CompactTimelineMolecule/HomeMode. Composes existing atoms only. See spec Reuse Audit
// (specs/stream-trajectory-tools.md).
//
// Source: design/metaspace-tools/metaspace-tools-v2.jsx:132-141.

import React from 'react';
import { useTranslation } from 'localization';
import ChipAtom from '../../atoms/Chip/ChipAtom';
import ButtonAtom from '../../atoms/Button/ButtonAtom';
import './StreamFacetBarMolecule.scss';

/** A lens is addressed by a stable `id` (persisted in `context_view_state`, emitted as the
 * analytics dimension) and rendered by its translated `label` — the two must never be the same
 * string, or translating the UI would silently orphan every stored view. */
export interface StreamLensOption {
  id: string;
  label: string;
}

export interface StreamFacetBarMoleculeProps {
  lenses: StreamLensOption[];
  /** The active lens's `id`, never its label. */
  activeLens: string | null;
  onSelectLens: (lensId: string | null) => void;
  onSaveAsView: () => void;
  className?: string;
}

const StreamFacetBarMolecule: React.FC<StreamFacetBarMoleculeProps> = ({
  lenses,
  activeLens,
  onSelectLens,
  onSaveAsView,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={['stream-facet-bar-molecule', className].filter(Boolean).join(' ')}>
      {lenses.map((lens) => (
        <ChipAtom
          key={lens.id}
          label={lens.label}
          tone={activeLens === lens.id ? 'claim' : 'neutral'}
          onClick={() => onSelectLens(activeLens === lens.id ? null : lens.id)}
        />
      ))}
      <ButtonAtom shape="pill" size="small" variant="secondary" icon="lucide:bookmark" label={t('stream.acts.saveAsView')} onClick={onSaveAsView} />
    </div>
  );
};

StreamFacetBarMolecule.displayName = 'StreamFacetBarMolecule';

export default StreamFacetBarMolecule;
